import { AppDispatch } from '../../types/store'
import { actionsActions } from '../slices/actionsSlice'

export const modifyActionParameter =
    (payload: { path: string[]; data: any }) => (dispatch: AppDispatch) => {
        dispatch(actionsActions.modifyActionParameter(payload))
    }

export const resetActionParameters =
    (payload: { guid: string; actionName: string }) =>
    (dispatch: AppDispatch) => {
        dispatch(actionsActions.resetActionParameters(payload))
    }

export const setActionInvalid =
    (payload: { path: string[] }) => (dispatch: AppDispatch) => {
        dispatch(actionsActions.setActionInvalid(payload))
    }

export const setActionValid =
    (payload: { path: string[] }) => (dispatch: AppDispatch) => {
        dispatch(actionsActions.setActionValid(payload))
    }

export const addCardItemToArrayEnd =
    (payload: { path: string[]; data: any }) => (dispatch: AppDispatch) => {
        dispatch(actionsActions.addCardItemToArrayEnd(payload))
    }

export const addCardItemToArrayBeginning =
    (payload: { path: string[]; data: any }) => (dispatch: AppDispatch) => {
        dispatch(actionsActions.addCardItemToArrayBeginning(payload))
    }

export const deleteItemFromArray =
    (payload: { path: string[] }) => (dispatch: AppDispatch) => {
        dispatch(actionsActions.deleteItemFromArray(payload))
    }

export const deleteBlockDictItem =
    (payload: { path: string[]; data: any; dictionaryKey: string }) =>
    (dispatch: AppDispatch) => {
        dispatch(actionsActions.deleteBlockDictItem(payload))
    }
